module.exports = __webpack_public_path__ + "static/case02-26ad2d5ee90a1d99e4a46e05a5e96d28.jpg";